class Chart {
  constructor() {}
}

export default Chart;
